import React from "react";
import { motion } from "framer-motion";
import SafeIcon from "../common/SafeIcon";
import * as FiIcons from "react-icons/fi";
import foucart from "../common/images/foucart.jpg";
import daviot from "../common/images/daviot.jpg";
import gosselin from "../common/images/gosselin2.jpg";
import receveau from "../common/images/receveau.jpg";
import salle1 from "../common/images/salle1.jpg";
import salle2 from "../common/images/salle2.jpg";
import salle3 from "../common/images/salle3.jpg";
import porte from "../common/images/porte.jpg";

const { FiUser, FiMail, FiPhone } = FiIcons;

const Equipe = () => {
  const membres = [
    {
      nom: "Séverine FOUCART",
      role: "Référent pédagogique",
      description:
        "Experte en ingénierie de formation et accompagnement pédagogique",
      icon: foucart,
      color: "bg-blue-100 text-blue-600",
    },
    {
      nom: "Timotée DAVIOT",
      role: "Référent communication",
      description:
        "Spécialiste en communication digitale et relation candidats",
      icon: daviot,
      color: "bg-green-100 text-green-600",
    },
    {
      nom: "Martin RECEVEAU",
      role: "Référent commercial & handicap",
      description: "Expert en solutions de financement et accessibilité",
      icon: receveau,
      color: "bg-purple-100 text-purple-600",
    },
    {
      nom: "Bruno GOSSELIN",
      role: "Directeur",
      description: "Directeur du groupe",
      icon: gosselin,
      color: "bg-orange-100 text-orange-600",
    },
  ];

  const galleryImages = [
    {
      src: porte,
      alt: "Espace Accueil",
      caption: "Espace Accueil",
    },
    {
      src: salle1,
      alt: "Salle de formation moderne",
      caption: "Notre salle de formation",
    },
    {
      src: salle2,
      alt: "FPA - Mise en situation",
      caption: "FPA - Mise en situation",
    },
    {
      src: salle3,
      alt: "Espace Détente",
      caption: "Espace Détente",
    },
  ];

  return (
    <section id="equipe" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Une équipe à votre écoute
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Des experts dédiés pour vous accompagner à chaque étape de votre
            parcours.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {membres.map((membre, index) => (
            <motion.div
              key={index}
              className="bg-white p-6 rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300"
            >
              <div
                className={`${membre.color} w-30 h-30 rounded-full flex items-center justify-center mx-auto mb-4`}
              >
                <img src={membre.icon} className="rounded-full" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 text-center mb-2">
                {membre.nom}
              </h3>
              <p className="text-blue-600 font-semibold text-center mb-3">
                {membre.role}
              </p>
              <p className="text-gray-600 text-xs text-center">
                {membre.description}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Gallery section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Nos locaux
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Découvrez les espaces où se déroulent nos formations.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {galleryImages.map((image, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-56 object-cover"
                />
                <div className="p-4">
                  <p className="text-gray-700 text-center font-medium">
                    {image.caption}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="bg-white rounded-2xl shadow-lg p-8"
        >
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">
                Contactez-nous
              </h3>
              <div className="space-y-4">
                <div className="flex items-center space-x-3">
                  <div className="bg-blue-100 p-2 rounded-lg">
                    <SafeIcon icon={FiMail} className="h-5 w-5 text-blue-600" />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Email</p>
                    <p className="text-gray-600">
                      contact@formateurpouradulte.fr
                    </p>
                  </div>
                </div>

                <div className="flex items-center space-x-3">
                  <div className="bg-green-100 p-2 rounded-lg">
                    <SafeIcon
                      icon={FiPhone}
                      className="h-5 w-5 text-green-600"
                    />
                  </div>
                  <div>
                    <p className="font-semibold text-gray-900">Téléphone</p>
                    <p className="text-gray-600">01 83 79 02 87</p>
                  </div>
                </div>
              </div>
            </div>

            <div
              id="contact-form"
              className="bg-gradient-to-br from-blue-50 to-indigo-100 p-6 rounded-xl"
            >
              <form
                name="contact"
                netlify
                action="/success.html"
                className="space-y-4"
              >
                <p>
                  <label>
                    Nom{" "}
                    <input
                      type="text"
                      name="name"
                      placeholder="Votre nom"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                    />
                  </label>
                </p>
                <p>
                  <label>
                    Email{" "}
                    <input
                      type="email"
                      name="email"
                      placeholder="Votre email"
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                    />
                  </label>
                </p>
                <p>
                  <button
                    type="submit"
                    className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200"
                  >
                    Envoyer ma demande
                  </button>
                </p>
              </form>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Equipe;
